export default "__VITE_ASSET__COg8j88w__"